import React, {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'
import LIFromFiltros from './Components/LIFromFiltros'
import TableListUsuario from './Components/TableListUsuario'
import './styles/lista-usuario.css'
import ModalsControls from './modals/ModalsControls'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionsGUListarUsuarios} from '../../../actions/action-creators'
import {gu_lu_Clear} from '../../../actions/gestion-usuario/lista-usuario/listaUsuario.actions'

const ListaUsuario = () => {
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUListarUsuarios, dispatch)
  useEffect(() => {
    window.scroll(0, 0)
    actions.gu_lu_GetUsuarios()
    return () => {
      dispatch(gu_lu_Clear())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BasicLayout>
      <ModalsControls />
      <div className='header'>
        <Link to='/gestion-usuarios' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Lista de Usuarios</h3>
      </div>
      <div className='separador'></div>
      <LIFromFiltros />
      <TableListUsuario />
    </BasicLayout>
  )
}

export default ListaUsuario
